import { TreatmentConfig } from '@smg-real-estate/vue-experiments';

import { SplitFeatureFlags } from './splitFeatureFlags';

export function getActiveTreatments(
  treatments: Record<string, TreatmentConfig>,
): Record<string, TreatmentConfig> {
  const activeFeatureFlags = Object.values(SplitFeatureFlags);

  return activeFeatureFlags.reduce<Record<string, TreatmentConfig>>(
    (activeTreatments, featureFlag) => {
      if (featureFlag in treatments) {
        activeTreatments[featureFlag] = treatments[featureFlag];
      }

      return activeTreatments;
    },
    {},
  );
}
